const about = {
  title: "How it works",
  contentSection: {
    title: "First, iizenglish offers:",
    paragraphs: [
      [
        "Interactive, self-correcting exercises (grammar, vocabulary, listening comprehension, and expression, as well as quizzes on English-speaking cultures) spanning CEFR levels A1, A2, B1 and B2.",
        "Mock tests for Ev{'@'}lang and English language certifications.",
        "A wide range of activities and materials designed to keep each student engaged and actively involved in their learning.",
        "Printable and downloadable worksheets.",
        "1,300 illustrations (created by Bod’Z, illustrator).",
        "2,000 audio recordings.",
      ],
      "Our exercises are based on rich cultural content, with numerous texts and audio materials related to the English-speaking world and current topics: everyday life (food, school system, hobbies, sports, my home, my neighbourhood), cultural insights (famous figures from the English-speaking world, gap year), and current issues (environement, fast fashion, overconsumption, gaming, Gen Z, social media, the Olympic Games).",
    ],
  },
  forWhoSection: {
    title: "Who is it for?",
    paragraphs: [
      "The platform can be used individually or as a teaching assistant for teachers and their classes.",
    ],
  },
  HowDoesItWorkSection: {
    title: "How does iizenglish work?",
    forIndividuals: {
      title: "FOR STUDENTS OR INDIVIDUAL USERS :",
      paragraphs: [
        "1. Simply sign up as a student by entering your first name, last name, email address and a password of your choice.",
        "2. You will then have access to the grammar and vocabulary contents, as well as a selection of free exercises to start practicing.",
        "3. To access all exercises and learning resources, you will need to subscribe to an annual plan.",
        "4. Once your online payment is completed, you’ll enjoy unlimited access to iizenglish, including all future updates.",
      ],
    },
    forTeachers: {
      title: "FOR TEACHERS:",
      paragraphs: [
        "1. Sign up as a teacher by entering your first name, last name, email address and a password of your choice.",
        "2. You will then have access to your teacher dashboard.",
        "3. Create your class by entering your students’ first names, last names and email addresses. Your students will receive an email inviting them to log in to iizenglish and subscribe to their annual plan.",
        "4. Once at least 10 students have subscribed, you will have full access to all contents and the associated worksheets for one year. You will also be able to create assignments for your students to complete in class or at home.",
        "5. The teacher subscription is free.",
      ],
    },
    forStudentsAttachedToTeacher: {
      title: "FOR STUDENTS CONNECTED TO A TEACHER:",
      paragraphs: [
        "1. You will receive an email inviting you to log in to iizenglish. Click the link in the email to create your password, or sign in with your existing credentials if you already have a personal account (If you already have an active subscription, you will be automatically linked to your teacher.).",
        "2. To receive your teacher’s assignments, you will need to subscribe to the annual plan directly on the website.",
        "3. Your teacher will then assign you activities to complete. You will also have access to all exercises and worksheets to practice whenever you want.",
        "4. When completing an assignment, you can try as many times as you like. Each attempt includes different sentences, making every assignment unique. Only your best score will be shared with your teacher.",
      ],
    },
  },
  AndNowSection: {
    title: "What's next?",
    paragraphs: [
      "I am a student or individual user :",
      "Subscribe directly on the website through secure payment.",
      "The annual subscription costs {price}.",
      "I am a teacher:",
    ],
    links: [
      "Create your account and subscribe.",
      "Sign up and create your first class",
    ],
  },
  bottomSection: {
    title: "HOW TO CONTACT US?",
    paragraphs: [
      "You can reach us by email at: {'contact@iizenglish.com'}",
      "If you represent a school, we can help you register your teachers and students automatically. Feel free to contact us.",
    ],
  },
};

export default about;
